/** CSS variable names for the design language fonts. Set automatically by fonts.css. */
export const FONT_SANS = '--font-sans'
export const FONT_MONO = '--font-mono'
export const FONT_RULES_COMPRESSED = '--font-rules-compressed'
export const FONT_RULES_EXPANDED = '--font-rules-expanded'
export const FONT_MONDWEST = '--font-mondwest'
